import { gql } from '@apollo/client';

export * from './escrowInvitationUpdate.mutation.generated';

export const ESCROW_INVITATION_UPDATE = gql`
  mutation escrowInvitationUpdate($escrowInvitationId: ID!, $escrowInvitationParams: EscrowInvitationUpdateParams!) {
    escrowInvitationUpdate(
      input: { escrowInvitationId: $escrowInvitationId, escrowInvitationParams: $escrowInvitationParams }
    ) {
      success
      errors
      escrowInvitation {
        ...EscrowInvitationFields
      }
    }
  }
`;
